import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTimeline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <rect width={10} height={1.5} x={2} y={3.5} rx={0.75} />
    <rect width={10} height={1.5} x={8} y={9} rx={0.75} />
    <rect width={10} height={1.5} x={2} y={15} rx={0.75} />
  </svg>
);
export default SvgTimeline;
